/**
 * Post-login landing route.
 *
 * The OAuth callback is handled server-side by a Lambda, which sets the session
 * cookie and redirects the browser back to the SPA (e.g. /queue). This route
 * exists as an explicit place to land / show errors surfaced via query params
 * (e.g. ?error=not_whitelisted) before bouncing onward.
 */
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ERROR_MESSAGES: Record<string, string> = {
  invalid_state: "Your sign-in link expired. Please try again.",
  missing_code: "The provider didn't return an authorization code.",
  not_whitelisted: "That account isn't on the approved admin list.",
  login_failed: "Something went wrong signing you in. Please try again.",
};

export function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const errorCode = params.get("error");
  const error = errorCode
    ? (ERROR_MESSAGES[errorCode] ?? `Sign-in error: ${errorCode}`)
    : null;

  useEffect(() => {
    if (!error) navigate("/queue", { replace: true });
  }, [error, navigate]);

  if (error) {
    return (
      <main style={{ maxWidth: 360, margin: "10vh auto", padding: 24 }}>
        <h1>Sign-in failed</h1>
        <p style={{ color: "#b00" }}>{error}</p>
        <a href="/login">Try again</a>
      </main>
    );
  }
  return <p style={{ padding: 24 }}>Signing you in…</p>;
}
